//SA UBACIVANJEM U PROP
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// Ažurirana EmojisChart komponenta koja koristi emojiData kao prop
const EmojisChart = ({ emojiData }) => {
  return (
    <div>
      <h2 className="text-lg font-bold mb-2 text-center mt-2">
        Grafik zadovoljstva
      </h2>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={emojiData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip
            content={({ payload }) => {
              return payload && payload.length ? (
                <div>
                  <p>
                    <strong>Datum:</strong> {payload[0].payload.date}
                  </p>
                  <p>
                    <strong>Kilogrami:</strong> {payload[0].value}
                  </p>
                  <p>
                    <strong>Emotikon:</strong> {payload[0].payload.emoji}
                  </p>
                </div>
              ) : null;
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="kg"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
            dot={(props) => {
              const { cx, cy, payload } = props;
              return (
                <text
                  x={cx}
                  y={cy}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="20"
                >
                  {payload.emoji}
                </text>
              );
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EmojisChart;

//BEZ UBACIVANJE U PROP
// import React from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";

// // Podaci
// const emojiData = [
//   { date: "2025-02-01", emoji: "😡", kg: 70 },
//   { date: "2025-02-02", emoji: "😞", kg: 71 },
//   { date: "2025-02-03", emoji: "😐", kg: 72 },
//   { date: "2025-02-04", emoji: "😐", kg: 71 },
//   { date: "2025-02-05", emoji: "😐", kg: 72 },
//   { date: "2025-02-06", emoji: "😊", kg: 73 },
//   { date: "2025-02-07", emoji: "😁", kg: 74 },
//   { date: "2025-02-08", emoji: "😁", kg: 75 },
//   { date: "2025-02-09", emoji: "😁", kg: 76 },
//   { date: "2025-02-10", emoji: "😡", kg: 77 },
//   { date: "2025-02-11", emoji: "😡", kg: 78 },
//   { date: "2025-02-12", emoji: "😊", kg: 79 },
// ];

// const EmojisChart = () => {
//   return (
//     <div>
//       <h2>Grafik Kilograma i Emotikona</h2>
//       <ResponsiveContainer width="100%" height={300}>
//         <LineChart
//           data={emojiData}
//           margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="date" />
//           <YAxis />
//           <Tooltip
//             content={({ payload }) => {
//               return payload && payload.length ? (
//                 <div>
//                   <p>
//                     <strong>Datum:</strong> {payload[0].payload.date}
//                   </p>
//                   <p>
//                     <strong>Kilogrami:</strong> {payload[0].value}
//                   </p>
//                   <p>
//                     <strong>Emotikoni:</strong> {payload[0].payload.emoji}
//                   </p>
//                 </div>
//               ) : null;
//             }}
//           />
//           <Legend />
//           <Line
//             type="monotone"
//             dataKey="kg"
//             stroke="#8884d8"
//             activeDot={{ r: 8 }}
//             dot={(props) => {
//               const { cx, cy, payload } = props;
//               return (
//                 <text
//                   x={cx}
//                   y={cy}
//                   textAnchor="middle"
//                   dominantBaseline="middle"
//                   fontSize="20"
//                 >
//                   {payload.emoji}
//                 </text>
//               );
//             }}
//           />
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default EmojisChart;
